import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";

@Injectable()
export class AnswerListService {
  apiEndPoint = environment.apiBaseUrl;
  constructor(private http: HttpClient, private router: Router) {}

  AnswerListCreate(id: number, name: any, checkListId: any) {
    return new Promise((resolve) => {
      const headers = new HttpHeaders();
      headers.append(
        "Authorization",
        "Bearer " + localStorage.getItem("token_user")
      ); // 'Bearer ' +
      headers.append("Content-Type", "application/json");
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token_user"),
          Accept: "application/json",
        }),
      };
      const postParams = {
        id: id,
        name: name,
        checkListId: checkListId,
      };
      this.http
        .post(
          this.apiEndPoint + "api/AnswerListCreate",
          postParams,
          httpOptions
        )
        .map((res) => res)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            resolve(error);
          }
        );
    });
  }

  activitiesList(id) {
    return new Promise((resolve) => {
      const headers = new HttpHeaders();
      headers.append(
        "Authorization",
        "Bearer" + localStorage.getItem("token_user")
      ); // 'Bearer ' +
      headers.append("Content-Type", "application/json");
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: "Bearer" + localStorage.getItem("token_user"),
          Accept: "application/json",
        }),
      };

      this.http
        .get(this.apiEndPoint + "api/activitiesList/" + id, httpOptions)
        .map((res) => res)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            resolve(error);
          }
        );
    });
  }

  eliminarAnswerList(id) {
    return new Promise((resolve) => {
      const headers = new HttpHeaders();
      headers.append(
        "Authorization",
        "Bearer" + localStorage.getItem("token_user")
      ); // 'Bearer ' +
      headers.append("Content-Type", "application/json");
      const httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: "Bearer" + localStorage.getItem("token_user"),
          Accept: "application/json",
        }),
      };

      this.http
        .get(this.apiEndPoint + "api/eliminarAnswerList/" + id, httpOptions)
        .map((res) => res)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            resolve(error);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/master-services/master-answer-list-services/answerList.service.ts